import type { DictFragment } from '../translations';

/** Task timeline, planning agenda, kanban boards and calendar strings. */
export const tasksPlanning: DictFragment = {
  fr: {
    // ── taskTimeline. ──
    'taskTimeline.updates': 'Mises à jour',
    'taskTimeline.noUpdates': 'Aucune mise à jour pour le moment.',
    'taskTimeline.updatesCount': '{n} mises à jour',
    'taskTimeline.replyBadge': 'réponse',
    'taskTimeline.reply': 'Répondre',
    'taskTimeline.editPlaceholder': 'Modifier la mise à jour…',
    'taskTimeline.commentPlaceholder': 'Écrire un commentaire… Utilisez @ pour mentionner',
    'taskTimeline.sendHint': 'Entrée pour envoyer · Maj+Entrée pour aller à la ligne',
    'taskTimeline.visibilityProject': 'Visible par les membres du projet',
    'taskTimeline.visibilityEveryone': 'Visible par tout le monde',
    'taskTimeline.deleteTitle': 'Supprimer la mise à jour',
    'taskTimeline.deleteMessage': 'Voulez-vous vraiment supprimer cette mise à jour ?',

    // ── planning. (Task Planning timeline — Jalons + Mes tâches) ──
    'planning.today': 'Aujourd’hui',
    'planning.jalons': 'Jalons',
    'planning.myTasks': 'Mes tâches',
    'planning.jumpToday': 'Aller à aujourd’hui',
    'planning.legendOverdue': 'En retard',
    'planning.legendSoon': 'Bientôt',
    'planning.emptyTitle': 'Rien à venir',
    'planning.emptyDesc': 'Aucun jalon ni tâche dans cette période.',

    // ── kanban. ──
    'kanban.col.backlog': 'En attente',
    'kanban.col.todo': 'À faire',
    'kanban.col.inProgress': 'En cours',
    'kanban.col.done': 'Terminé',
    'kanban.col.archived': 'Archivées',
    'kanban.cardHint': 'Cliquer pour modifier · glisser pour déplacer',
    'kanban.cardTitlePlaceholder': 'Titre de la carte…',
    'kanban.addCard': 'Ajouter une carte',
    'kanban.editCard': 'Modifier la carte',
    'kanban.optionalDetails': 'Détails facultatifs…',
    'kanban.dueDate': 'Échéance',
    'kanban.assignee': 'Assigné·e',
    'kanban.unassigned': 'Non assigné·e',
    'kanban.deleteCardTitle': 'Supprimer la carte',
    'kanban.deleteCardMsg': 'Supprimer cette carte ? Cette action est irréversible.',
    'kanban.members': 'Membres',
    'kanban.invitePeople': 'Inviter des personnes',
    'kanban.pickPerson': 'Choisir une personne…',
    'kanban.noOneToInvite': 'Personne à inviter',
    'kanban.owner': 'propriétaire',
    'kanban.removeMember': 'Retirer le membre',
    'kanban.boardNotFound': 'Tableau introuvable.',
    'kanban.boards': 'Tableaux',
    'kanban.newBoardPlaceholder': 'Nom du nouveau tableau…',
    'kanban.myBoards': 'Mes tableaux',
    'kanban.boardsLabel': 'Tableaux',
    'kanban.allBoards': 'Tous les tableaux',
    'kanban.noBoardsYet': 'Aucun tableau pour le moment',
    'kanban.noBoardsShared': 'Aucun tableau partagé avec vous pour le moment',
    'kanban.emptyDesc': 'Créez un tableau ci-dessus, ou demandez à un collègue de vous inviter au sien.',
    'kanban.memberCountOne': '{n} membre',
    'kanban.memberCountMany': '{n} membres',
    'kanban.copyBoardLink': 'Copier le lien vers ce tableau',
    'kanban.copyCardLink': 'Copier le lien vers cette carte',

    // ── calendar. ──
    'calendar.day.mon': 'Lun',
    'calendar.day.tue': 'Mar',
    'calendar.day.wed': 'Mer',
    'calendar.day.thu': 'Jeu',
    'calendar.day.fri': 'Ven',
    'calendar.month.jan': 'janv.',
    'calendar.month.feb': 'févr.',
    'calendar.month.mar': 'mars',
    'calendar.month.apr': 'avr.',
    'calendar.month.may': 'mai',
    'calendar.month.jun': 'juin',
    'calendar.month.jul': 'juil.',
    'calendar.month.aug': 'août',
    'calendar.month.sep': 'sept.',
    'calendar.month.oct': 'oct.',
    'calendar.month.nov': 'nov.',
    'calendar.month.dec': 'déc.',
    'calendar.due': 'Échéance {date}',
    'calendar.removeFromCalendar': 'Retirer du calendrier',
    'calendar.prevWeek': 'Semaine précédente',
    'calendar.nextWeek': 'Semaine suivante',
    'calendar.thisWeek': 'Cette semaine',
    'calendar.jumpThisWeek': 'Aller à cette semaine',
    'calendar.weekNum': 'Semaine {n}',
    'calendar.myTasks': 'Mes tâches à planifier',
    'calendar.trayHint': 'Glissez une tâche dans la semaine : elle reste dans cette liste, vous pouvez la planifier autant de fois que nécessaire.',
    'calendar.trayEmpty': 'Aucune tâche en cours ne vous est assignée.',
    'calendar.mine': 'Mon calendrier',
    'calendar.personHelp': 'Voir le calendrier d’une autre personne (PMO et accompagnant·es PMO)',
    'calendar.tasksOf': 'Tâches de {name}',
    'calendar.readOnlyHint': 'Calendrier de {name}, en lecture seule : seule cette personne place et déplace ses séances.',
    'calendar.trayEmptyOther': 'Aucune tâche en cours n’est assignée à {name}.',
    'calendar.group.overdue': 'Échéance dépassée',
    'calendar.group.soon': 'Échéance dans moins d’une semaine',
    'calendar.group.later': 'Plus tard ou sans échéance',
    'calendar.dueOverdue': 'Échéance dépassée · {date}',
    'calendar.dueToday': 'Échéance aujourd’hui',
    'calendar.dueTomorrow': 'Échéance demain',
    'calendar.dueInDays': 'Échéance dans {n} jours · {date}',
    'calendar.sessionsThisWeek': '{n}× cette semaine',
    'calendar.sessionsThisWeekHelp': 'Nombre de fois où cette tâche est planifiée dans la semaine affichée',
    'calendar.resize': 'Glisser pour changer la durée',
    'calendar.privateTask': 'Tâche privée',
    'calendar.legend.session': 'Tâche planifiée',
    'calendar.legend.outlook': 'Rendez-vous Outlook',
    'calendar.legend.soon': 'Échéance < 1 semaine',
    'calendar.legend.overdue': 'Échéance dépassée',
    'calendar.legend.done': 'Tâche terminée',
    'calendar.projectOverview': 'Aperçu du projet',
    'calendar.projectOverviewHelp': 'Afficher l’aperçu du projet',
    'calendar.openProjectPage': 'Ouvrir la fiche projet',
    'calendar.overviewLoadFailed': 'Impossible d’afficher l’aperçu de ce projet.',
    'calendar.kanbanBoard': 'Tableau Kanban',
    'calendar.outlookHint': 'Chaque séance est aussi copiée dans votre calendrier Outlook (titre « t-ae14 … », détails de la tâche) ; elle suit vos déplacements, disparaît quand vous la retirez, et supprimer le rendez-vous dans Outlook retire aussi la séance ici.',
    'calendar.outlookSynced': 'Dans votre calendrier Outlook',
    'calendar.outlookFailed': 'Pas encore copiée dans Outlook — nouvel essai automatique',
  },
  en: {
    // ── taskTimeline. ──
    'taskTimeline.updates': 'Updates',
    'taskTimeline.noUpdates': 'No updates yet.',
    'taskTimeline.updatesCount': '{n} updates',
    'taskTimeline.replyBadge': 'reply',
    'taskTimeline.reply': 'Reply',
    'taskTimeline.editPlaceholder': 'Edit update...',
    'taskTimeline.commentPlaceholder': 'Write a comment... Use @ to mention',
    'taskTimeline.sendHint': 'Enter to send · Shift+Enter for a new line',
    'taskTimeline.visibilityProject': 'Visible to project members',
    'taskTimeline.visibilityEveryone': 'Visible to everyone',
    'taskTimeline.deleteTitle': 'Delete Update',
    'taskTimeline.deleteMessage': 'Are you sure you want to delete this update?',

    // ── planning. (Task Planning timeline — Jalons + Mes tâches) ──
    'planning.today': 'Today',
    'planning.jalons': 'Milestones',
    'planning.myTasks': 'My tasks',
    'planning.jumpToday': 'Jump to today',
    'planning.legendOverdue': 'Overdue',
    'planning.legendSoon': 'Soon',
    'planning.emptyTitle': 'Nothing coming up',
    'planning.emptyDesc': 'No milestones or tasks in this period.',

    // ── kanban. ──
    'kanban.col.backlog': 'Backlog',
    'kanban.col.todo': 'To Do',
    'kanban.col.inProgress': 'In Progress',
    'kanban.col.done': 'Done',
    'kanban.col.archived': 'Archived',
    'kanban.cardHint': 'Click to edit · drag to move',
    'kanban.cardTitlePlaceholder': 'Card title…',
    'kanban.addCard': 'Add a card',
    'kanban.editCard': 'Edit card',
    'kanban.optionalDetails': 'Optional details…',
    'kanban.dueDate': 'Due date',
    'kanban.assignee': 'Assignee',
    'kanban.unassigned': 'Unassigned',
    'kanban.deleteCardTitle': 'Delete card',
    'kanban.deleteCardMsg': 'Delete this card? This cannot be undone.',
    'kanban.members': 'Members',
    'kanban.invitePeople': 'Invite people',
    'kanban.pickPerson': 'Pick a person…',
    'kanban.noOneToInvite': 'No one left to invite',
    'kanban.owner': 'owner',
    'kanban.removeMember': 'Remove member',
    'kanban.boardNotFound': 'Board not found.',
    'kanban.boards': 'Boards',
    'kanban.newBoardPlaceholder': 'New board name…',
    'kanban.myBoards': 'My boards',
    'kanban.boardsLabel': 'Boards',
    'kanban.allBoards': 'All boards',
    'kanban.noBoardsYet': 'No boards yet',
    'kanban.noBoardsShared': 'No boards shared with you yet',
    'kanban.emptyDesc': 'Create a board above, or ask a teammate to invite you to theirs.',
    'kanban.memberCountOne': '{n} member',
    'kanban.memberCountMany': '{n} members',
    'kanban.copyBoardLink': 'Copy link to this board',
    'kanban.copyCardLink': 'Copy link to this card',

    // ── calendar. ──
    'calendar.day.mon': 'Mon',
    'calendar.day.tue': 'Tue',
    'calendar.day.wed': 'Wed',
    'calendar.day.thu': 'Thu',
    'calendar.day.fri': 'Fri',
    'calendar.month.jan': 'Jan',
    'calendar.month.feb': 'Feb',
    'calendar.month.mar': 'Mar',
    'calendar.month.apr': 'Apr',
    'calendar.month.may': 'May',
    'calendar.month.jun': 'Jun',
    'calendar.month.jul': 'Jul',
    'calendar.month.aug': 'Aug',
    'calendar.month.sep': 'Sep',
    'calendar.month.oct': 'Oct',
    'calendar.month.nov': 'Nov',
    'calendar.month.dec': 'Dec',
    'calendar.due': 'Due {date}',
    'calendar.removeFromCalendar': 'Remove from calendar',
    'calendar.prevWeek': 'Previous week',
    'calendar.nextWeek': 'Next week',
    'calendar.thisWeek': 'This week',
    'calendar.jumpThisWeek': 'Jump to this week',
    'calendar.weekNum': 'Week {n}',
    'calendar.myTasks': 'My tasks to plan',
    'calendar.trayHint': 'Drag a task into the week: it stays in this list, so you can plan it as many times as you need.',
    'calendar.trayEmpty': 'No open task is assigned to you.',
    'calendar.mine': 'My calendar',
    'calendar.personHelp': 'See another person’s calendar (PMO and PMO accompanists)',
    'calendar.tasksOf': 'Tasks of {name}',
    'calendar.readOnlyHint': '{name}’s calendar, read-only: only they place and move their sessions.',
    'calendar.trayEmptyOther': 'No open task is assigned to {name}.',
    'calendar.group.overdue': 'Overdue',
    'calendar.group.soon': 'Due within a week',
    'calendar.group.later': 'Later or no due date',
    'calendar.dueOverdue': 'Overdue · {date}',
    'calendar.dueToday': 'Due today',
    'calendar.dueTomorrow': 'Due tomorrow',
    'calendar.dueInDays': 'Due in {n} days · {date}',
    'calendar.sessionsThisWeek': '{n}× this week',
    'calendar.sessionsThisWeekHelp': 'How many times this task is planned in the week shown',
    'calendar.resize': 'Drag to change the duration',
    'calendar.privateTask': 'Private task',
    'calendar.legend.session': 'Planned task',
    'calendar.legend.outlook': 'Outlook meeting',
    'calendar.legend.soon': 'Due < 1 week',
    'calendar.legend.overdue': 'Overdue',
    'calendar.legend.done': 'Done task',
    'calendar.projectOverview': 'Project overview',
    'calendar.projectOverviewHelp': 'Show the project overview',
    'calendar.openProjectPage': 'Open the project page',
    'calendar.overviewLoadFailed': 'This project’s overview can’t be shown.',
    'calendar.kanbanBoard': 'Kanban board',
    'calendar.outlookHint': 'Each session is also copied into your Outlook calendar (title “t-ae14 …”, the task’s details); it follows when you move it, disappears when you remove it, and deleting the appointment in Outlook removes the session here too.',
    'calendar.outlookSynced': 'In your Outlook calendar',
    'calendar.outlookFailed': 'Not yet copied to Outlook — retried automatically',
  },
};
